import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { Box } from "@mui/material";
import "./Dialog.css";
import CloseIcon from "@mui/icons-material/Close";
import ButtonCompo from "../ButtonComponent/ButtonCompo";

export default function DialogComponentSingleBtn({
    open,
    title,
    subHeading,
    subText,
    rightBtnText,
    leftBtnText,
    leftBtnClick,
    rightBtnClick,
    onClose,
}) {
    return (
        <Dialog
            open={open}
            aria-labelledby="report-dialog-title"
            aria-describedby="report-dialog-description"
            sx={{
                "& .MuiDialog-paper": {
                    width: "100%",
                },
            }}
        >
            <Box className="dialog-container">
                <div className="dialog-inner-div">
                    <CloseIcon
                        className="close-icon-popup"
                        size="small"
                        sx={{ color: "grey" }}
                        onClick={onClose}
                    />
                    <div className="dialog-text-div">
                        <p className="dialog-title">{title}</p>
                        {subHeading ? (
                            <p className="dialog-title">{subHeading}</p>
                        ) : (
                            <p className="dialog-subtext">{subText}</p>
                        )}
                    </div>
                    <div className="button-group-div-dialog">
                        <ButtonCompo btnOutlined
                            onClick={leftBtnClick}
                            btnText={leftBtnText}
                        />
                    </div>
                </div>
            </Box>
        </Dialog>
    );
}
